import styled from 'styled-components'
import { DEVICE } from '../../../util/constants'
import { GriddedContentBlock } from '../../styles/Utility.styles'
import { BodyCopy } from './BodyContentBlock.styles'

export const AdvancedForm = styled(GriddedContentBlock)`
  /* Naming Convenience */
  margin-top: 0;

  & > div {
    display: flex;
    grid-column: 2 / 12;
    flex-direction: column;

    @media ${DEVICE.tabletL} {
      width: 100%;
      flex-direction: row;
    }
  }
`

export const FormContainer = styled.div`
  width: 100%;
  order: ${({ mobile_layout }) =>
    mobile_layout === 'Form Top->Image Bottom' ? 1 : 2};
  margin: ${({ mobile_layout }) =>
    mobile_layout === 'Form Top->Image Bottom' ? '0 0 20px 0' : '20px 0 0 0'};
  @media ${DEVICE.tabletL} {
    min-width: 370px;
    order: ${({ desktop_layout }) =>
      desktop_layout === 'Form Left->Image Right' ? 1 : 2};
    margin: ${({ desktop_layout }) =>
      desktop_layout === 'Form Left->Image Right'
        ? '0 80px 0 0'
        : '0 0 0 80px'};
  }
`

export const TextAndImageContainer = styled.div`
  order: ${({ mobile_layout }) =>
    mobile_layout === 'Form Top->Image Bottom' ? 2 : 1};
  text-align: center;
  height: auto;
  margin-top: 20px;
  display: flex;
  flex-direction: column;

  @media ${DEVICE.tabletL} {
    order: ${({ desktop_layout }) =>
      desktop_layout === 'Form Left->Image Right' ? 2 : 1};
    text-align: left;
    margin-top: unset;
  }
`

export const UpperContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  display: flex;
  z-index: 2;

  & > picture {
    width: 100%;
    box-sizing: border-box; /* ensures padding is included in the width */

    img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      object-fit: cover;
      display: block;
    }
  }
`

export const LowerContainer = styled.div`
  width: 100%;
  background-color: var(--content-background-light);
  margin-top: -40px;
  border-radius: 5px;
`

export const LowerContainerCopy = styled(BodyCopy)`
  margin: 60px 30px 30px 30px;
  font-size: 1.6rem;
`
